import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox, Space } from 'antd';
import Span from 'src/components/ui/Span';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormOptionsWithEnglishValues, getFormInstructions } from 'src/helpers/multilingualHelper';

const normalizeArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);

const MultipleSelectClientForm = ({ elementId, label, name, required, options, control, errors, config, onChange, value }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayOptions = getFormOptionsWithEnglishValues(options, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);
    const hasError = !!errors[elementId];

    return (
        <div className="relative inline-block w-full">
            <label htmlFor={elementId} className={`block ${config.hasInstructions ? '' : 'mb-2'} text-sm  text-gray-700`}>
                {displayLabel}{required && '*'}
            </label>
            {config.hasInstructions && (
                <label className="mb-2 text-xs  text-gray-300">
                    {displayInstructions}
                </label>
            )}
            <Controller
                name={elementId}
                control={control}
                rules={{
                    validate: (v) => {
                        if (!required) return true;
                        const arr = normalizeArray(v);
                        return arr.length > 0 || t('form.thisFieldRequired');
                    },
                }}
                render={({ field }) => {
                    const isEmptyArray = !Array.isArray(field.value) || field.value.length === 0;
                    if (isEmptyArray && value && normalizeArray(value).length > 0) {
                        field.onChange(normalizeArray(value));
                    }

                    const selected = Array.isArray(field.value) ? field.value : [];

                    return (
                        <Checkbox.Group
                            id={elementId}
                            value={selected}
                            onChange={(next) => {
                                field.onChange(next);
                                onChange && onChange(elementId, null, next);
                            }}
                            className="w-full"
                        >
                            <Space direction="vertical">
                                {displayOptions.map((option, index) => (
                                    <Checkbox key={`${elementId}-${index}`} value={option.value}>
                                        {option.label}
                                    </Checkbox>
                                ))}
                            </Space>
                        </Checkbox.Group>
                    );
                }}
            />
            {hasError && (
                <Span className="text-FailRed400 text-xxs">
                    {errors[elementId].message || t('form.thisFieldRequired')}
                </Span>
            )}
        </div>
    );
};

export default MultipleSelectClientForm;
